import { Injectable } from '@angular/core';
import * as m from 'moment-timezone';
import { unitOfTime } from 'moment';

@Injectable({
  providedIn: 'root'
})
export class DateTimeService {

  timestampToDate(ts: any) {
    return new Date(ts * 1000);
  }

  concatDate(ts: number) {
    const date = new Date(ts * 1000);
    const ago = this.ago(date);
    const day = this.dateToFromNowDaily(date);
    const time = this.convertFilingTime(date);
    return ago + ' | ' + time;
  }

  dateToFromNowDaily(myDate) {
    // get from-now for this date
    const fromNow = m(myDate).fromNow();

    // ensure the date is displayed with today and yesterday
    return m(myDate).calendar(null, {
      // when the date is closer, specify custom values
      sameDay: '[Today]',
      lastDay: '[Yesterday]',
      // when the date is further away, use from-now functionality
      sameElse() {
        return '';
      }
    });
  }

  ago(date) {
    const str = m(date).fromNow();
    if (str.includes('hours') && this.isCharNumber(str[1]) || str.includes('day')) {
      return m.tz(new Date(date), 'America/New_York').format('MMM Do');
    }
    return m(date).fromNow();
  }

  agoPure(date) {
    return m(date).fromNow();
  }

  monthAndDay(date: Date) {
    if (this.dateToFromNowDaily(date).includes('Today')) {
      return this.dateToFromNowDaily(date);
    } else {
      return m.tz(new Date(date), 'America/New_York').format('MMM Do');
    }
  }

  convertFilingTime(date: Date) {
    return m.tz(date, 'America/New_York').format('HH:mm:ss');
  }

  convertFilingTimeShort(date: Date) {
    return m.tz(date, 'America/New_York').format('MMMM D h:mm A');
  }

  convertFilingDate(date: Date) {
    return m.tz(date, 'America/New_York').format('YY-MM-DD HH:mm:ss');
  }

  convertFilingDateNoSecs(date: Date) {
    return m.tz(date, 'America/New_York').format('YY-MM-DD HH:mm');
  }

  convertFilingDateShort(date: Date) {
    return m.tz(date, 'America/New_York').format('MMM D');
  }

  convertFilingDay(date: Date) {
    return m.tz(date, 'America/New_York').format('dd');
  }

  getTimestampPeriodAgo(period: string, num: number) {
    // tslint:disable-next-line: deprecation
    return m().subtract(period as unitOfTime.DurationConstructor, num).unix();
  }

  getCurrentTimestampSecs() {
    return m().unix();
  }

  isCharNumber(c) {
    return c >= '0' && c <= '9';
  }

  // append zero to date and time
  a(n) {
    if (n <= 9) {
      return '0' + n;
    }
    return n;
  }
}
